<h2 mat-dialog-title>{{ data }}</h2>
<mat-dialog-actions align="end">
  <button
    mat-button
    mat-raised-button
    cdkFocusInitial
    color="primary"
    mat-dialog-close
  >
    {{ "intimation.ok" | translate }}
  </button>
</mat-dialog-actions>
